import store from '@/state/store'

const isParent = store.getters['identity/isParent'](isParent)
export default function getFields(instance) {
  return [
    {
      label: instance.$t('report.fields.company'),
      key: 'company',
      isShow:
        store.getters['identity/hasAccess'](['a10e-report-child-monitoring:read']) && isParent,
    },
    {
      label: instance.$t('report.fields.licensePlate'),
      key: 'license_plate',
      isShow: true,
    },
    {
      label: instance.$t('report.fields.fleetCategory'),
      key: 'fleet_category',
      isShow: true,
    },
    {
      label: instance.$t('report.fields.fleetType'),
      key: 'fleet_type',
      isShow: true,
    },
    {
      label: instance.$t('report.fields.fleetBrand'),
      key: 'fleet_brand',
      isShow: true,
    },
    {
      label: instance.$t('report.fields.unitYear'),
      key: 'unit_year',
      isShow: true,
    },
    {
      label: instance.$t('report.fields.fleetAge'),
      key: 'fleet_age',
      isShow: true,
    },
    {
      label: instance.$t('report.fields.totalFo'),
      key: 'total_fo_assigned',
      isShow: true,
    },
    {
      label: instance.$t('report.fields.possibleTime'),
      key: 'possible_time',
      isShow: true,
    },
    {
      label: instance.$t('report.fields.availableTime'),
      key: 'available_time',
      isShow: true,
    },
    {
      label: instance.$t('report.fields.operationsTime'),
      key: 'operations_time',
      isShow: true,
    },
    {
      label: instance.$t('report.fields.averageUtilization'),
      key: 'average_utilization',
      isShow: true,
    },
    {
      label: instance.$t('report.fields.averageAvailability'),
      key: 'average_availability',
      isShow: true,
    },
    {
      label: instance.$t('report.fields.onTimeDelivery'),
      key: 'on_time_delivery',
      isShow: true,
    },
    {
      label: instance.$t('report.fields.TotalOnTimeDelivery'),
      key: 'total_do_on_time',
      isShow: true,
    },
  ]
}
